/**
 * CGCLoopCTA — Call-to-action banner for CGC Submission Loop.
 * LAUNCH:C6.P3
 */
import React from 'react';
import { Trophy } from 'lucide-react';

export default function CGCLoopCTA({ vaultItemId, gradeValue, confidence, onStartLoop }) {
  return (
    <div
      className="rounded-lg p-3 bg-gradient-to-r from-orange-500 to-orange-600"
      role="region"
      aria-label="CGC Submission Loop"
    >
      <div className="flex items-start gap-3">
        <Trophy className="w-5 h-5 text-white flex-shrink-0 mt-0.5" aria-hidden="true" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-white">Submit for Professional Grading</p>
          <p className="text-xs text-orange-100 mt-0.5">
            Earn up to 175 points and verify your AI grade
          </p>
          <button
            onClick={() => onStartLoop?.({ vaultItemId, gradeValue, confidence })}
            className="mt-2 px-3 py-1.5 bg-white/20 hover:bg-white/30 text-white text-xs font-medium rounded transition-colors"
            aria-label="Start CGC Submission Loop and earn up to 175 points"
          >
            Start Loop
          </button>
        </div>
      </div>
    </div>
  );
}
